import React from 'react';
import { Checkbox } from 'antd';

const FoodkidList = ({ menuList, onChangeCheckAll, ...props }) => (
    <div className="row">
        <div className="col-lg-12">
            <div className="panel panel-white ">
                <table className="table table-togglable table-hover table-bordered">
                    <thead>
                        <tr>
                            <th
                                className="text-center footable-visible footable-last-column"
                                style={{ width: '35px' }}
                            >
                                <Checkbox
                                    checked={
                                        menuList.length > 0 &&
                                        menuList.filter((o) => o.is_update)
                                            .length === menuList.length
                                    }
                                    onChange={onChangeCheckAll}
                                />
                            </th>
                            <th
                                className="text-center"
                                data-toggle="true"
                                style={{ width: '10%' }}
                            >
                                Mã thực đơn mẫu
                                <span className="display-block text-muted">
                                    Sĩ số dự trù
                                </span>
                            </th>
                            <th className="text-center" style={{ width: '8%' }}>
                                Tiền định mức
                                <span className="display-block text-muted">
                                    Tiền dư
                                </span>
                            </th>
                            <th
                                className="text-center"
                                data-hide="phone"
                                style={{ width: '8%' }}
                            >
                                Tiền một trẻ
                                <span className="display-block text-muted">
                                    Tiền dịch vụ
                                </span>
                            </th>
                            <th className="text-center" data-hide="phone">
                                Món ăn
                            </th>
                            <th
                                className="text-center"
                                style={{ width: '12%' }}
                            >
                                Ngày lập
                            </th>
                            <th
                                className="text-center"
                                data-hide="phone"
                                style={{ width: '8%' }}
                            >
                                Sĩ số thực tế
                            </th>
                            <th
                                className="text-center"
                                style={{ width: '80px' }}
                            >
                                Tình trạng
                            </th>
                        </tr>
                    </thead>
                    <tbody>{props.children}</tbody>
                </table>
            </div>
        </div>
    </div>
);

export default FoodkidList;
